var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"px-0"},[_c('b-input-group',[_c('b-select',{attrs:{"state":!_vm.v.$anyError && null,"value":_vm.field,"options":_vm.filteredFields},on:{"input":function($event){return _vm.$emit('update:field', $event)}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }